import React from 'react';
import { SubscriptionPlans } from '../../components/SubscriptionPlans';

export function Subscription() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: '500', margin: '0 0 2rem 0' }}>Subscription Plans</h1>
      <SubscriptionPlans />
    </div>
  );
}
